import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "react-day-picker/style.css";
import "./index.css";
import 'tiptap-extension-resizable-image/styles.css';


import * as Sentry from "@sentry/react";

console.log(import.meta.env.NODE_ENV);

if (import.meta.env.NODE_ENV != "development") {
  Sentry.init({
    dsn: "https://cbfe46962bd1f7840d2686ec8bfa4f0b@o297264.ingest.us.sentry.io/4509672412413952",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracePropagationTargets: ["localhost", import.meta.env.VITE_API_BASE_URL],
    sendDefaultPii: true,
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

createRoot(document.getElementById("root")!).render(<App />);
